import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { HotelResultsContainer } from '@hotels/hotel-results/hotel-results.container';
import { HotelsFiltersComponent } from './components/hotels-filters/hotels-filters.component';
import {
  SearchBarMobileCalendarContainer
} from '@shared/base-search-bar/components/calendar/components/search-bar-mobile-calendar/search-bar-mobile-calendar.container';
import { 
  HOTELS_FILTERS_ROUTE, 
  HOTEL_BYHOURS_RESULTS_ROUTE, 
  HOTEL_BYHOURS_ROUTE, 
  HOTEL_RESULTS_ROUTE 
} from '@hotels/hotel-results/constants/routes';
import { HotelRoomsMobileComponent } from '@hotels/hotel-detail/components/hotel-rooms-mobile/hotel-rooms-mobile.component';
import {
  IndividualHotelFilterContainer
} from '@shared/magic-filter-bar/individual-hotel-filter/individual-hotel-filter.container';

export const hotelResultsRootRoute = HOTEL_RESULTS_ROUTE;
export const hotelByhoursRootRoute = HOTEL_BYHOURS_ROUTE;
export const byhoursRootRoute = HOTEL_BYHOURS_ROUTE;
export const byhoursResultsRootRoute = HOTEL_BYHOURS_RESULTS_ROUTE;
export const hotelsFiltersRoute = HOTELS_FILTERS_ROUTE;
export const hotelsCalendarRoute = 'hotels-calendar';
export const calendarRoute = 'calendar';
export const hotelRoomsRootRoute = 'hotel-rooms';
export const singleFilterRoute = 'single-filter';

export const routes: Routes = [
  {
    path: `${byhoursResultsRootRoute}/:destination_type/:destination_id/:check_in/:currency_code/:rooms/:pack_hour`,
    component: HotelResultsContainer,
    data: { IS_BYHOURS: true },
    children: [{
      outlet: 'outlet',
      path: hotelsFiltersRoute,
      component: HotelsFiltersComponent
    },
    {
      outlet: 'outlet',
      path: hotelsCalendarRoute,
      component: SearchBarMobileCalendarContainer,
    },
    {
      path: calendarRoute,
      outlet: 'search',
      component: SearchBarMobileCalendarContainer,
    },
    {
      path: hotelRoomsRootRoute,
      outlet: 'hotel-detail',
      component: HotelRoomsMobileComponent
    },
    {
      path: singleFilterRoute,
      outlet: 'outlet',
      component: IndividualHotelFilterContainer
    }]
  },
  {
    path: ':destination_type/:destination_id/:check_in/:check_out/:currency_code/:rooms',
    component: HotelResultsContainer,
    children: [{
      outlet: 'outlet',
      path: hotelsFiltersRoute,
      component: HotelsFiltersComponent
    },
    {
      outlet: 'outlet',
      path: hotelsCalendarRoute,
      component: SearchBarMobileCalendarContainer,
    },
    {
      path: calendarRoute,
      outlet: 'search',
      component: SearchBarMobileCalendarContainer,
    },
    {
      path: hotelRoomsRootRoute,
      outlet: 'hotel-detail',
      component: HotelRoomsMobileComponent
    },
    {
      path: singleFilterRoute,
      outlet: 'outlet',
      component: IndividualHotelFilterContainer
    }]
  }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HotelResultsRoutingModule { }
